import { Col, Input, Row } from "antd";
import { LoadingOutlined, EditOutlined } from "@ant-design/icons";
import React, { useEffect } from "react";
import Clipboard from "../Clipboard";
import ModelConfirm from "../ModalConfirm";
var InputInlineEdit = function (props) {
    var className = props.className, loading = props.loading, span = props.span, onSubmit = props.onSubmit, editable = props.editable, formatValue = props.formatValue, formatDisplay = props.formatDisplay, defaultValue = props.defaultValue, copiable = props.copiable, messageConfirm = props.messageConfirm, confirmable = props.confirmable, iconEdit = props.iconEdit;
    var _a = React.useState(false), isEdit = _a[0], setEdit = _a[1];
    var refInput = React.useRef(null);
    var _b = React.useState(defaultValue), value = _b[0], setValue = _b[1];
    var _c = React.useState(false), showModalConfirm = _c[0], setShowConfirm = _c[1];
    useEffect(function () {
        if (!loading && !isEdit && showModalConfirm)
            setShowConfirm(false);
    }, [defaultValue, loading, value]);
    var onEndEdit = function (event) {
        event.preventDefault();
        setEdit(false);
        if (defaultValue && value && defaultValue === value)
            return;
        if (confirmable) {
            setShowConfirm(true);
        }
        else
            submit();
    };
    var submit = function () {
        if (onSubmit)
            onSubmit(value);
    };
    var clickEdit = function () {
        setEdit(true);
        setTimeout(function () {
            if (refInput && refInput.current)
                refInput.current.focus();
        }, 100);
    };
    var onChange = function (e) {
        var value = e.target.value;
        setValue(formatValue ? formatValue(value) : value);
    };
    var closeConfirm = function () {
        setShowConfirm(false);
        setEdit(false);
        setValue(defaultValue);
    };
    return React.createElement(Col, { span: span ? span : 24 },
        React.createElement(Row, { className: "dpl-flex align-items-center " + className },
            React.createElement(Col, { span: 20 },
                React.createElement(Input, { className: "align-items-center", ref: refInput, style: { borderRadius: 3 }, suffix: copiable && !isEdit && !loading && React.createElement(Clipboard, { value: value, className: '_copy' }), disabled: !isEdit, value: formatDisplay ? formatDisplay(value) : value, onBlur: onEndEdit, onPressEnter: onEndEdit, onChange: onChange })),
            React.createElement(Col, { span: 4, className: 'pdl5' }, !editable ? null : loading && !showModalConfirm ?
                React.createElement(LoadingOutlined, { style: { fontSize: 15 }, className: "icon-edit" }) : !isEdit ?
                iconEdit ? iconEdit : React.createElement(EditOutlined, { className: '_edit cursor-pointer icon-edit', onClick: clickEdit }) : null)),
        showModalConfirm && React.createElement(ModelConfirm, { loading: loading, visible: showModalConfirm, onCancel: closeConfirm, onSubmit: submit, content: messageConfirm ? messageConfirm : 'Bạn có chắc muốn sửa thông tin?' }));
};
InputInlineEdit.defaultProps = {
    copiable: true,
    span: 24,
    editable: true,
    isConfirm: false,
};
export default InputInlineEdit;
